import { createPortal } from 'react-dom';
import { ERROR_PAGE } from '@app/constants/targets';
import ErrorPage from './ErrorPage';
import { PageLoader } from 'cat-ecommerce-alloy';
import { Suspense } from 'react';

const Container = () => {
  const errorPageTarget = document.getElementById(ERROR_PAGE);
  return errorPageTarget
    ? createPortal(
        <Suspense fallback={<PageLoader />}>
          <ErrorPage />
        </Suspense>,
        errorPageTarget
      )
    : null;
};

export default Container;
